import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const QUERY_KEY = 'cookie-policy-content'
const ENDPOINT = 'CustomerProfile/Content/CookiePolicy'

export function fetchCookiePolicyContent() {
  return axiosInstance.get<any>(ENDPOINT).then((response) => response.data.data)
}

export function useCookiePolicyContentQuery(
  options?: UseQueryOptions<
    Awaited<ReturnType<typeof fetchCookiePolicyContent>>
  >
) {
  return useQuery({
    queryFn: fetchCookiePolicyContent,
    queryKey: [QUERY_KEY],
    ...options,
  })
}
